import { combineReducers } from "redux";

import { authentication } from "./authentication.reducer";
import { registration } from "./registration.reducer";
import { alert } from "./alert.reducer";
import { campaigns } from "./campaigns.reducer";
import { heatmap } from "./heatmap.reducer";
import { location } from "./location.reducer";
import { chart } from "./chart.reducer";
import { noti }	from "./notification.reducer";
import { devs }	from "./device.reducer";
const rootReducer = combineReducers({
    authentication,
    registration,
    alert,
    campaigns,
    heatmap,
    location,
    chart,
    noti,
    devs
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/_reducers/index.js